module.exports = __webpack_public_path__ + "img/119.5751314d.gif";